import { useDispatch, useSelector } from "react-redux"
import { DropdownSearchBar } from "../DropdownSearchBar/DropdownSearchBar"
import { NavbarSearchActions, NavbarSearchSelector } from "shared/reducers/NavbarSearch"
import { useCallback } from "react";


export const MainSearchController = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(NavbarSearchSelector).open;
    
    const onClose = useCallback(() => {
        !isOpen && dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    } , [dispatch, isOpen])

    return <DropdownSearchBar autoOpen orientation={'right'} onClose={onClose} />
}import { useDispatch, useSelector } from "react-redux"
import { DropdownSearchBar } from "../DropdownSearchBar/DropdownSearchBar"
import { NavbarSearchActions, NavbarSearchSelector } from "shared/reducers/NavbarSearch"
import { useCallback } from "react";


export const MainSearchController = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(NavbarSearchSelector).open;
    
    const onClose = useCallback(() => {
        !isOpen && dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    } , [dispatch, isOpen])

    return <DropdownSearchBar autoOpen orientation={'right'} onClose={onClose} />
}